( function(global, $) {
    "use strict";

    var moveTabs = function(tabs) {
        var nav = tabs.querySelector('[tabs-nav]');
        nav.addEventListener('click', function(event) {
            event.preventDefault();

            var target = global.methods.closest('a', event.target);
            var paneID = target.href.split('#')[1];
            var activePane = document.getElementById(paneID);

            if (!target.parentNode.classList.contains('active')) {
                // deactivate existing active tab and panel
                var actives = tabs.querySelectorAll('.active');
                for (var i=0; i < actives.length; i++){
                    actives[i].classList.remove('active');
                }
                // activate new tab and panel
                target.parentNode.classList.add('active');
                activePane.classList.add('active');
            }
        }, false);
    }

    // app instantiation
    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        if ($container.find('[tabs]').length) {
            var tabs = $container.find('[tabs]');
            for (var i = 0; i < tabs.length; i++) {
                moveTabs(tabs[i]);
            }
        }
    });

}(window.groots, jQuery));
